
document.addEventListener("DOMContentLoaded", () => {
	

	/* QUICK ADD TO CART COLLECTION PAGES */
	document.body.addEventListener( 'click', function ( event ) {
	  if(event.target.className.length > -1 && ( event.target.className.indexOf('show-variations') > -1 ||  event.target.className.indexOf('overlayRej') > -1 )  ) {
	    	action_variations(event);
	  };
	}); 

	function action_variations(event) {
		let productCard   = event.target.parentNode;
	    let featuredProductVariationContainer = productCard.getElementsByClassName('featured-product-variation-container')[0];
	    let featuredProductVariationOverlay = productCard.getElementsByClassName('overlayRej')[0];
	    featuredProductVariationContainer.classList.toggle('active');
	    featuredProductVariationOverlay.classList.toggle('active');  
	}


	/* PRODUCT PAGE - POPULATE YOTPO RATINGS ON PRODUCT PAGE*/
	waitForElm('.yotpo-bottom-line-score').then((elm) => {
		if(document.querySelector('.rating')) {
			document.querySelector('.rating').style.opacity = 1;
		    document.querySelector('.rating .stars .value').style.width = parseFloat(elm.textContent) / 5 * 100 + '%';
		    document.querySelector(".rating .numeral").innerHTML = elm.textContent;
		}
	    
	});

	waitForElm('.yotpo-bottom-line-basic-text').then((elm) => {
		if(document.querySelector('.rating')) {
	    	document.querySelector(".rating .count").innerHTML = elm.textContent;
	    }
	});


	document.querySelectorAll('.featured_collections_filter div').forEach(function(elem) {
	    elem.addEventListener("click", function(event) {
	    	let elems = document.querySelectorAll(".featured_collections_filter div");
	    	[].forEach.call(elems, function(el) {
	    		el.classList.remove('active');
	    	});
	    	let collection = event.target.dataset.collection
	    	event.target.classList.add('active');
	    	

	    	let elemColecs = document.querySelectorAll(".featured_collection_products");
	    	[].forEach.call(elemColecs, function(el) {
	    		el.classList.remove('active');
	    	});
	    	document.querySelector('[data-name="'+collection+'"]').classList.add('active');
	    	
	    });
	});




	if(document.querySelector(".backinstock-form__btn button")){
		document.querySelector(".backinstock-form__btn button").addEventListener("click",  function(event) {
		
			let form = event.target.closest(".backinstock-form");
			let klaviyokey = form.dataset.klaviyokey;
			const searchParams = new URLSearchParams(window.location.search);
			var variantId = searchParams.get('variant');
			const el = document.querySelector("[data-addtocart-id1]");

			if(el != undefined && el != null){
			    variantId = el.getAttribute("data-addtocart-id1");  
			} 

			let email = form.querySelector(".backinstock-form__email").value;
			
			if (!isValidEmail(email)) {
				form.querySelector(".backinstock-form__error-msg").classList.remove("hidden")
				return;
			}
			


			const options = {
			  method: 'POST',
			  headers: {
			    accept: 'application/json',
			    revision: '2023-08-15',
			    'content-type': 'application/json'
			  },
			  body: JSON.stringify({
			    data: {
			      type: 'back-in-stock-subscription',
			      attributes: {
			        channels: ['EMAIL'],
			        profile: {
			          data: {
			            type: 'profile',
			            attributes: {
			              email: email
			            }
			          },
			          email: email
			        }
			      },
			      relationships: {
			        variant: {
			          data: {
			            type: 'catalog-variant',
			            id: `$shopify:::$default:::${variantId}`
			          }
			        }
			      }
			    }
			  })
			};

			fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id='+klaviyokey, options)
			  .then(response =>  {
			  	
			  	if(response.ok) {

		      		form.querySelector(".backinstock-form__success-msg").classList.remove("hidden")
		      		form.querySelector(".backinstock-form__wrapper").classList.add("hidden")
		      		form.querySelector(".backinstock-form__error-msg").classList.add("hidden")
		      	}else {
		      		form.querySelector(".backinstock-form__error-msg").classList.remove("hidden")     		
		      	}
			  })
			.catch(err => console.error(err));
		
		});
	}

	function isValidEmail(value){
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(value).toLowerCase());
    };


    /* PRODUCT PAGE - UPDATE ALL OPTIONS SIZE ON THE PAGE */

	document.body.addEventListener("click", function(event) {
	  if (event.target.matches('.product-card__atc-pack-btn .button')) {
	    event.preventDefault();
	    
	    let productForm = event.target.closest('.product__options-form');
		let productVariants = JSON.parse(productForm.getAttribute('data-variants'));
		let selectedOptions = {};
		let parentWrapper = event.target.closest('.product__options-form__wrapper');

		const buttons = parentWrapper.querySelectorAll('.product-card__atc-pack-btn .button');

		
		// Boucle dessus
		buttons.forEach((el) => {
			el.classList.remove('is-active');
		    if(el.innerHTML == event.target.innerHTML) {
		    	el.classList.add('is-active');
		    }
		});

		let activeOptions = productForm.querySelectorAll('.product-card__atc-pack-btn .button.is-active');

		if(activeOptions.length >=2) {
			activeOptions.forEach(function(option) {
				
			    // Récupérer 'data-option-name' et 'data-option-value' pour chaque option
			    let optionName = option.getAttribute('data-option-name');
			    let optionValue = option.getAttribute('data-option-value');
			    
			    // Ajouter ces valeurs à l'objet selectedOptions
			    selectedOptions[optionName] = optionValue; 
			});
			

			let variantID = null;
			let isAvailable = false;
			productVariants.forEach(function(variant) {
			    let match = true;
			    
			    // Vérifier si les options du variant correspondent à celles sélectionnées
			    for (let optionName in selectedOptions) {
			        let variantOption = variant.options.find(option => option.name === optionName);
			        
			        if (!variantOption || variantOption.value !== selectedOptions[optionName]) {
			            match = false;
			            break;
			        }
			    }

			    if (match) {
			        variantID = variant.id;
			        isAvailable = variant.available; 
			    }
			});

			productForm.querySelectorAll('.addtocart').forEach(function(elem) {
				elem.setAttribute("data-addtocart-id1", variantID); 
				elem.click();
			});

		}
		
	  }
	});


	/* PRODUCT PAGE - UPDATE ALL OPTIONS SIZE ON THE PAGE */
	let elementsArray = document.querySelectorAll('.product__options-form__wrapper .product__options-form__value');
	elementsArray.forEach(function(elem) {
	    elem.addEventListener("click", function(event) {
	    	let productForm = this.closest('.product__options-form');
			let productVariants = JSON.parse(productForm.getAttribute('data-variants'));

			// Stocker les options sélectionnées (ex: {option1: "34", option2: "Noir"})
			let selectedOptions = {};

	    	let parentWrapper = this.closest('.product__options-form__wrapper');

	        let allWrappers = document.querySelectorAll(`#${parentWrapper.id}`);

            // Initialiser le tableau pour stocker les éléments
            let elems = [];

            // Trouver tous les .product__options-form__value dans ces div et les ajouter au tableau
            allWrappers.forEach(wrapper => {
                let options = wrapper.querySelectorAll('.product__options-form__value');
                options.forEach(option => {
                    elems.push(option); // Ajouter à l'array
                });
            });


            [].forEach.call(elems, function(el) {

			    el.classList.remove('is-active');
			    if(el.innerHTML == event.target.innerHTML) {
			    	el.classList.add('is-active');
			    }
			});

			let activeOptions = productForm.querySelectorAll('.product__options-form__value.is-active');

		
			activeOptions.forEach(function(option) {
			    // Récupérer 'data-option-name' et 'data-option-value' pour chaque option
			    let optionName = option.getAttribute('data-option-name');
			    let optionValue = option.getAttribute('data-option-value');
			    
			    // Ajouter ces valeurs à l'objet selectedOptions
			    selectedOptions[optionName] = optionValue;
			});



			// Trouver l'ID de la variante qui correspond aux options sélectionnées
			let variantID = null;
			let isAvailable = false;
			productVariants.forEach(function(variant) {
			    let match = true;
			    
			    // Vérifier si les options du variant correspondent à celles sélectionnées
			    for (let optionName in selectedOptions) {
			        let variantOption = variant.options.find(option => option.name === optionName);
			        
			        if (!variantOption || variantOption.value !== selectedOptions[optionName]) {
			            match = false;
			            break;
			        }
			    }

			    if (match) {
			        variantID = variant.id;
			        isAvailable = variant.available; 
			    }
			});

	        
	        let url = new URL(window.location.href);
    		url.searchParams.set("variant", variantID), window.history.replaceState({}, "", url.toString());

    	
	        document.querySelectorAll('.addtocart').forEach(function(elem) {
				elem.setAttribute("data-addtocart-id1", variantID); 
			});
			
			if(!isAvailable) {
				document.querySelector('.product__atc-wrapper').style.display = 'none';
				document.querySelector('.outofstock__msg').style.display = 'flex';
				document.querySelector(".product-desktop-widget .product__atc-wrapper .addtocart").style.visibility = 'hidden';
			}else {
				document.querySelector('.product__atc-wrapper').style.display = 'flex';
				document.querySelector('.outofstock__msg').style.display = 'none';
				document.querySelector(".product-desktop-widget .product__atc-wrapper .addtocart").style.visibility = 'visible';
			}

	    });
	});


	if(document.querySelector('.packs_container')) {
		let elementsPacksArray = document.querySelector('.packs_container').querySelectorAll('.pack_option');
		elementsPacksArray.forEach(function(elem) {
		    elem.addEventListener("click", function(event) {
		        
		    	var target = event.target

				var qty = target.getAttribute("data-pack-qty1");
				var id = target.getAttribute("data-pack-id1");

				document.querySelectorAll('.addtocart').forEach(function(elem) {
					elem.setAttribute("data-addtocart-qty1", qty); 
					elem.setAttribute("data-addtocart-id1", id); 

				});

				var parent = target.parentElement.parentElement;
				parent.querySelectorAll('.pack_option').forEach(el => {
			        el.classList.remove('is-active')
			    });
				target.classList.add('is-active')

				
		    });
		});

		var dataAddtocartQty1 = document.querySelector('.product-form').querySelector('.addtocart').getAttribute("data-addtocart-qty1");
		var dataAddtocartId1 = document.querySelector('.product-form').querySelector('.addtocart').getAttribute("data-addtocart-id1");
		let elementsPacksTogglerArray = document.querySelectorAll('.pack_toggler');
		elementsPacksTogglerArray.forEach(function(elem) {
		    elem.addEventListener("click", function(event) {
		        
		    	var target = event.target;

				document.querySelectorAll('.pack_toggler').forEach(function(elem) {
					elem.classList.remove('active')

				});
				target.classList.add('active');

				if(target.classList.contains("packs")) {
					dataAddtocartQty1 = document.querySelector('.product-form').querySelector('.addtocart').getAttribute("data-addtocart-qty1");
					dataAddtocartId1 = document.querySelector('.product-form').querySelector('.addtocart').getAttribute("data-addtocart-id1");
					document.querySelector('.simple-variations').classList.add("hidden");
					document.querySelector('.packs_container').classList.remove("hidden");
				}else {
					document.querySelector('.simple-variations').classList.remove("hidden");
					document.querySelector('.packs_container').classList.add("hidden");
					resetPacksOption();
				}
				
		    });
		});

		let elementsPacksContainerArray = document.querySelectorAll('.pack_container');
		elementsPacksContainerArray.forEach(function(elem) {
		    elem.addEventListener("click", function(event) { 
		    	var target = event.target
				if(!target.classList.contains("pack_option")) {
					document.querySelectorAll('.pack_container').forEach(function(elem) {
						elem.classList.remove('active');
					});
					resetPacksOption();
					target.classList.add('active');
				}
				
		    });
		});
	}
	


	function resetPacksOption() {
		document.querySelectorAll('.pack_option').forEach(function(elem) {
			elem.classList.remove('is-active');
		});

		 document.querySelector('.product-form').querySelectorAll('.addtocart').forEach(function(elem) {
		 		elem.setAttribute("data-addtocart-qty1", dataAddtocartQty1)
		 		elem.setAttribute("data-addtocart-id1", dataAddtocartId1)
		});
		

		
	}

	if(document.querySelector('.ensemble_container')) {
		let elementsEnsembleArray = document.querySelector('.ensemble_container').querySelectorAll('.pack_option');
		elementsEnsembleArray.forEach(function(elem) {
		    elem.addEventListener("click", function(event) {
		        
		    	var target = event.target;
		    	//console.log(target);
				var qty = target.getAttribute("data-pack-qty1");
				var id = target.getAttribute("data-pack-id1");

				document.querySelector(".ensemble_container").querySelectorAll('.addtocart').forEach(function(elem) {
					elem.setAttribute("data-addtocart-qty1", qty); 
					elem.setAttribute("data-addtocart-id1", id); 

				});

				var parent = target.parentElement.parentElement;
				parent.querySelectorAll('.pack_option').forEach(el => {
			        el.classList.remove('is-active')
			    });
				target.classList.add('is-active')

				
		    });
		});
	}
	


	/* PRODUCT PAGE - ATC DESKTOP WIDGET HIDE SHOW VARIATION */
	if(document.querySelector('.product-desktop-widget')) {
		document.querySelector('.product-desktop-widget .size-select-widget').addEventListener("click", function(event) {
			event.target.classList.toggle('showVariations'); 
			document.querySelector('.product-desktop-widget .product__options-form').classList.toggle('is-open'); 
		});

		var threashold = 700;
		if(document.querySelector("body").classList.contains("landing-page-int")) {
			threashold = 2000;
		}
		document.addEventListener("scroll", function() { 
			var scrollAmt = window.pageYOffset || document.documentElement.scrollTop; 
			if(scrollAmt >= threashold) {
			   document.querySelector('.product-desktop-widget').classList.add('show');
			 } else {
			    document.querySelector('.product-desktop-widget').classList.remove('show');
			}
		});
	}


	/* COLLECTION PAGE READ MORE */
	if(document.querySelector(".collection-description .read-more")){
		document.querySelector(".collection-description .read-more").addEventListener("click",  function(event) {
			event.preventDefault();
			event.target.parentElement.querySelector('.richtext').classList.toggle('collapsed'); 
		});
	}

	const languageTogglers = document.querySelectorAll('.language-toggler');

    languageTogglers.forEach(toggler => {
      toggler.addEventListener('click', function (e) {
        const container = toggler.closest('.language-container');
        const list = container.querySelector('.countryList');
        list.classList.toggle('open');
      });
    });

    /* PACK PRICE PER UNIT */
	document.querySelectorAll('.pack_price_per_unit').forEach(function(el) {
		const title = el.dataset.title;
		const price = parseInt(el.dataset.price, 10); // prix en centimes

		// Récupère le premier chiffre trouvé dans le titre
		const match = title.match(/\d+/);

		const titleProduct = el.dataset.titleProduit;


		if (match) {
			const quantity = parseInt(match[0], 10);

			if (quantity > 0) {
				const unitPrice = price / quantity / 100; // conversion centimes -> euros

				el.textContent = "soit " + unitPrice.toFixed(2).replace('.', ',') + ' € par '+titleProduct;
			}
		}
	});
	
});


function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}



